module.exports = __webpack_public_path__ + "media/slide2/contractMediaSlide2Part1-a6945bea.png";